export const renderStatus = (status) => {
  switch (status) {
    case 0:
      return <span className="label label-new">New</span>;
    case 1:
      return (
        <span className="label label-supervisor">Supervisor Approved</span>
      );
    case 2:
      return <span className="label label-pcard">PCard Approved</span>;
    case 3:
      return <span className="label label-hold">On Hold</span>;
    case 4:
      return (
        <span className="label label-assist-requested">
          Assistance Requested
        </span>
      );
    case 5:
      return (
        <span className="label label-assist-approval">Assistance Approved</span>
      );
    case 6:
      return <span className="label label-ordered">Ordered</span>;
    case 7:
      return <span className="label label-shipped">Shipped</span>;
    case 8:
      return <span className="label label-delivering">Out for Delivery</span>;
    case 9:
      return <span className="label label-delivered">Delivered</span>;
    case 10:
      return <span className="label label-denied">Denied</span>;
    case 11:
      return <span className="label label-order-cancelled">Cancelled</span>;
    case 12:
      return <span className="label label-stockout">Out of Stock</span>;
    case 13:
      return <span className="label label-edited">Order Edited</span>;
    case 15:
      return <span className="label label-Processing">Order Processing</span>;
    default:
      return null;
  }
};

export function renderUrgency(urgency) {
  switch (urgency) {
    case 0:
      return <span className="label label-danger">High</span>;
    case 1:
      return <span className="label label-warning">Standard</span>;
    case 2:
      return <span className="label label-info">Low</span>;
    default:
      return null;
  }
}
